module.exports = __webpack_public_path__ + "img/3.d20ba8be.jpg";